<section class="admin-users">

  <div class="admin-users__toolbar">
    <button type="button" class="btn btn--primary btn--sm" data-id="btn-new-client">
      <i class="icon icon--plus"></i> <%= _lcs( 'Neuen Client anlegen' ) %>
    </button>
  </div>

  <!-- Grid (or loading / empty / error message) is rendered here by ClientUser.js -->
  <div class="admin-users__state" data-id="users-state"></div>

  <!-- Create / edit modal (web component) -->
  <client-user-form data-id="client-form"></client-user-form>

  <!-- Read-only details modal (web component) -->
  <client-user-detail data-id="client-detail"></client-user-detail>

</section>
